export default __webpack_public_path__ + "assets/workWithUs.png";